export interface GameSettings {
  readonly poolPoints: number
  readonly doublingCountRounds: number
}

export const gameSettingsNull: GameSettings = {
  poolPoints: 0,
  doublingCountRounds: 0,
}
